import { Box } from "@mui/joy";
import { Link } from "react-router-dom";
import { Button } from "../../../../../shared";

export function Action({ api }: { api: any }) {
    return (
        <Box display={"flex"} gap={2} mt={2}>
            <Button
                variant="soft"
                color="neutral"
                component={Link}
                to="/admin/organizations"
                disabled={api.isPending}
            >
                Cancel
            </Button>
            <Button
                type="submit"
                loading={api.isPending}
            >
                Save
            </Button>
        </Box>
    );
}
